import { DBConfig } from 'ngx-indexed-db';
import { environment } from '../environments/environment';

export const enum OBJECT_STORES {
    CARDS = 'cards',
    USERS = 'users',
    ORGANIZATIONS = 'organizations',
}

export const indexedDBConfig: DBConfig = {
    name: environment.INDEX_DB_NAME,
    version: 1,
    objectStoresMeta: [
        {
            store: OBJECT_STORES.CARDS, // Name of the store
            storeConfig: {
                keyPath: 'id', // Primary key for DigitalBusinessCard
                autoIncrement: false, // Don't auto-increment, since `id` is provided
            },
            storeSchema: [
                { name: 'id', keypath: 'id', options: { unique: true } },
                {
                    name: 'card_data',
                    keypath: 'card_data',
                    options: { unique: false },
                },
            ],
        },
        {
            store: OBJECT_STORES.USERS,
            storeConfig: {
                keyPath: 'id', // Primary key for User
                autoIncrement: false,
            },
            storeSchema: [
                { name: 'id', keypath: 'id', options: { unique: true } },
                {
                    name: 'user_data',
                    keypath: 'user_data',
                    options: { unique: false },
                },
            ],
        },
        {
            store: OBJECT_STORES.ORGANIZATIONS,
            storeConfig: {
                keyPath: 'id', // Primary key for Organization
                autoIncrement: false,
            },
            storeSchema: [
                { name: 'id', keypath: 'id', options: { unique: true } },
                {
                    name: 'org_data',
                    keypath: 'org_data',
                    options: { unique: false },
                },
            ],
        },
    ],
};
